import { BehaviorSubject } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GQL } from '@pass-frontend/data-access/state-management/apollo';
import { eventBus } from '@pass-frontend/utility/event-bus';

/** A Behavior Subject (a Subject with .value property) */
const rewardsCredited = new BehaviorSubject<number>(0);
eventBus
  .query((e) => {
    return GQL.next.match(e) && e.payload.operation === 'REWARDS_DOLLAR_AMOUNT';
  })
  .pipe(
    // The rewardsDollarAmount in the payload..
    map((e) => e.payload.rewardsDollarAmount?.onePassCredit?.amount),
    filter((amount) => !!amount),
  )
  .subscribe(rewardsCredited);

/** @example
 *  ```
 *   // For current value:
 *   const rewardsCredited = useRewardsChange().value
 *   // For a Promise for a value (if it might not have a value yet)
 *   const rewardsCredited = await firstValueFrom(useRewardsChange())
 * ```
 */
export const useRewardsChange = () => {
  return rewardsCredited;
};
